'use client';
import type React from 'react';
import { useCallback, useState } from 'react';

import useSessionStorage from '@cineamo/composables/src/hooks/useSessionStorage';

import PageLeaveTracker from '@cineamo/composables/src/PageLeaveTracker';
import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';
import { useCartProvider } from '@cineamo/composables/src/providers/cartProvider';
import PageLeaveWarningModal from '@cineamo/composables/src/ticket-booking/PageLeaveWarningModal';

import { useRouter } from '@/i18n/routing';

const BookingPageLeaveTracker = () => {
    const [pageLeaveWarningModalIsOpen, setPageLeaveWarningModalIsOpen] = useState(false);
    const [nextRoute, setNextRoute] = useState<string | null>(null);
    const router = useRouter();
    const { total, items, currentStep } = useCartProvider();
    const [isPageHaveUnsavedChanges] = useSessionStorage('isPageHaveUnsavedChanges', 'false');
    const { track } = useAnalytics();

    const onNavigate = useCallback(
        (href: string) => {
            if (isPageHaveUnsavedChanges === 'true') {
                setPageLeaveWarningModalIsOpen(true);
                setNextRoute(href);
                return true;
            }
            return false;
        },
        [isPageHaveUnsavedChanges]
    );

    const handleConfirm = () => {
        setPageLeaveWarningModalIsOpen(false);
        if (nextRoute) {
            track('Checkout Abandoned', {
                cartTotal: total.toString(),
                cartItemsCount: items.length,
                nextRoute: nextRoute,
                currentStep: currentStep
            });
            router.push(nextRoute);
            setNextRoute(null);
        }
    };

    const handleCancel = () => {
        track('Checkout Abandon Canceled', {
            cartTotal: total.toString(),
            cartItemsCount: items.length,
            nextRoute: nextRoute,
            currentStep: currentStep
        });
        setPageLeaveWarningModalIsOpen(false);
        setNextRoute(null);
    };

    return (
        <>
            <PageLeaveTracker onNavigate={onNavigate} />
            {pageLeaveWarningModalIsOpen && (
                <PageLeaveWarningModal
                    modalIsOpen={pageLeaveWarningModalIsOpen}
                    setModalIsOpen={setPageLeaveWarningModalIsOpen}
                    onClose={() => setPageLeaveWarningModalIsOpen(false)}
                    handleConfirm={handleConfirm}
                    handleCancel={handleCancel}
                />
            )}
        </>
    );
};

export default BookingPageLeaveTracker;
